import type { InjectionKey } from 'vue';
import type { AudioPlayer } from './services/AudioPlayer';
import type { SpotifyService } from './services/SpotifyService';

export const audioPlayerKey = Symbol('audioPlayer') as InjectionKey<AudioPlayer>;
export const spotifyServiceKey = Symbol('spotifyService') as InjectionKey<SpotifyService>;
